import { isLottolandNativeAppUserAgent } from '../helpers/isLottolandNativeAppUserAgent/isLottolandNativeAppUserAgent';

const NATIVE_APP_ATTRIBUTE = 'data-native-app';

// Must stay self-contained: its source is inlined into the page via Function.prototype.toString.
/* istanbul ignore next */
function setNativeAppAttribute(isNativeAppUserAgent: (userAgent: string) => boolean, attribute: string): void {
  if (isNativeAppUserAgent(navigator.userAgent)) {
    document.documentElement.setAttribute(attribute, '');
  }
}

const NATIVE_APP_DETECTION_SCRIPT = `(function(){try{(${setNativeAppAttribute.toString()})(${isLottolandNativeAppUserAgent.toString()},'${NATIVE_APP_ATTRIBUTE}');}catch(e){}})();`;

// Same logic as NATIVE_APP_DETECTION_SCRIPT, for pages React renders on the client, where that inline script never runs.
const markNativeAppDocument = (): void => setNativeAppAttribute(isLottolandNativeAppUserAgent, NATIVE_APP_ATTRIBUTE);

export { markNativeAppDocument, NATIVE_APP_ATTRIBUTE, NATIVE_APP_DETECTION_SCRIPT };
